/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Group_HelpInputs */



/**
* | output |
* | --- |
* | "Choose an existing group or create a new one" |
*
* @param {Marker_Import_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_group_help = /** @type {((inputs?: Marker_Import_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez un groupe existant ou creez-en un nouveau")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine bestehende Gruppe aus oder erstellen Sie eine neue.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli un gruppo esistente o creane uno nuovo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите существующую группу или создайте новую.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elija un grupo existente o cree uno nuevo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择现有群组或创建新群组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("既存のグループを選択するか、新しいグループを作成します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("किसी मौजूदा समूह को चुनें या एक नया समूह बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolha um grupo existente ou crie um novo.")
	return /** @type {LocalizedString} */ ("Choose an existing group or create a new one")
});